import * as NavigationBar from 'expo-navigation-bar';
import { Center, HStack, Pressable, Text } from 'native-base';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

function TabBar({ tabs }) {
  useEffect(() => {
    NavigationBar.setVisibilityAsync('visible');
    NavigationBar.setButtonStyleAsync('light');
    NavigationBar.setBackgroundColorAsync('#023047');
  }, []);
  return (
    <HStack bg="#023047">
      {tabs.map((tab) => (
        <Pressable
          key={tab.id}
          onPress={tab.onPress}
          onLongPress={tab.onLongPress}
          py="3"
          flex={1}
          android_ripple={{ color: '#ffffff', radius: 65 }}
        >
          {({ isPressed }) => (
            <Center>
              {React.cloneElement(tab.icon(), {
                size: 'sm',
                mb: '1',
                color: tab.isFocused || isPressed ? '#ffffff' : 'gray.400',
              })}
              <Text
                color={tab.isFocused || isPressed ? '#ffffff' : 'gray.400'}
                fontSize="13"
              >
                {tab.label}
              </Text>
            </Center>
          )}
        </Pressable>
      ))}
    </HStack>
  );
}

TabBar.propTypes = {
  tabs: PropTypes.array.isRequired,
};

export default TabBar;
